import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { denyExternalFlightBookingRequestForAdminApi } from './denyExternalFlightBookingRequestForAdmin.api'
import denyExternalFlightBookingRequestForAdminInitialState from './denyExternalFlightBookingRequestForAdmin.initialState'
import {
  DenyExternalFlightBookingRequestForAdminErrorResponse,
  DenyExternalFlightBookingRequestForAdminRequestPayload
} from './denyExternalFlightBookingRequestForAdmin.types'

export const denyExternalFlightBookingRequestForAdmin = createAsyncThunk(
  urls.admin.denyExternalFlightBookingRequestForAdmin,
  async (payload: DenyExternalFlightBookingRequestForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await denyExternalFlightBookingRequestForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const denyExternalFlightBookingRequestForAdminSlice = createSlice({
  name: urls.admin.denyExternalFlightBookingRequestForAdmin,
  initialState: denyExternalFlightBookingRequestForAdminInitialState,
  reducers: {
    resetDenyExternalFlightBookingRequestForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(denyExternalFlightBookingRequestForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(denyExternalFlightBookingRequestForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(denyExternalFlightBookingRequestForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as DenyExternalFlightBookingRequestForAdminErrorResponse
        state.success = null
      })
  }
})

export const {
  actions: denyExternalFlightBookingRequestForAdminActions,
  reducer: denyExternalFlightBookingRequestForAdminReducer
} = denyExternalFlightBookingRequestForAdminSlice
export const { resetDenyExternalFlightBookingRequestForAdmin } = denyExternalFlightBookingRequestForAdminActions
export default denyExternalFlightBookingRequestForAdminSlice.reducer
